import { darken } from 'polished';
import styled from 'styled-components';

import { FocusButton } from '@main/pc-core-components';
import { sp, timing } from '@main/theme';

/**
 * The SideMenuCollapsed bar wrapper
 */
export const SideMenuCollapsedWrapper = styled(FocusButton)`
  position: relative;
  z-index: 999; // z-index should be less than take control (which is 1000)
  width: 100%;
  background-color: ${({ theme }) => theme.colors.sidebarNavBg};
  padding: ${sp(2)} ${sp(2)} ${sp(2)} ${sp(3.25)};
  cursor: pointer;
  transition: ${timing.shortEase('background-color', 'color')};
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.sidebarNavBg)};
  }
`;

/**
 * The HideMenu wrapper
 */
export const HideMenuWrapper = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.textOnSidebar};
  font-size: ${sp(2.2)};
`;

/**
 * The Label wrapper
 */
export const LabelWrapper = styled.div`
  display: block;
  text-align: left;
`;

/**
 * The MainNav wrapper
 */
export const MainNavWrapper = styled.h2`
  margin: 0 0 ${sp(0.5)} 0;
  color: ${({ theme }) => theme.colors.textOnSidebar};
`;

/**
 * The SubNav wrapper
 */
export const SubNavWrapper = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textOnSidebar};
  opacity: 0.8;
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
`;

/**
 * The SideMenu full screen wrapper
 */
export const SideMenuWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.sidebarNavBg};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 4000;
  overflow: auto;
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};
`;

/**
 * The SidebarMobile wrapper
 */
export const SidebarMobileWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.sidebarNavBg};
`;
